import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

import DateTimePicker from '../DateTimePicker'

class DateTimePickerForm extends React.Component {
  render() {
    const { setValue, getValue, getErrorMessage, isValid, isRequired, isPristine, value, onChange, className, ...props } = this.props;
    const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid form-control p-0' : '';

    const handleChange = (date) => {
      setValue(date);
      onChange && onChange(date);
    };

    return <React.Fragment>
      <DateTimePicker {...pick(props, Object.keys(DateTimePicker.propTypes).concat(['name']))}
        value={getValue ? getValue() : value}
        onChange={handleChange}
        className={`${className || ''} ${isInvalidClass}`}
      />
      <span className="invalid-feedback">
        {isRequired() && !getValue() && ' Field required'}
      </span>
    </React.Fragment>
  }
}

export default withFormsy(DateTimePickerForm);
